import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  loggedin = false;
  private formSubmitAttempt: boolean;
  isLoggedIn$: Observable<boolean>;
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.loggedin = localStorage.getItem('loggedin') === 'true';
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  isFieldInvalid(field: string) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }

  onSubmit() {
    if (this.form.valid) {
    }
    this.formSubmitAttempt = true;
  }

  toggleCollapse() {
  }
}
